// preferredName resolves the human-facing name to SHOW for a person, preferring
// real name fields, then the chosen USERNAME, then handle/alias, and finally the
// legacy display_name (deprecated as a shown value, kept only as a last-ditch
// fallback for old records). Returns '' when nothing usable is present so callers
// can apply their own generic fallback ('Someone' / 'Subscriber').
export function preferredName(p: {
  fullName?: string | null;
  username?: string | null;
  handle?: string | null;
  display_name?: string | null;
}): string {
  return (
    (p.fullName || '').trim() ||
    (p.username || '').trim() ||
    (p.handle || '').trim() ||
    (p.display_name || '').trim() ||
    ''
  );
}
